React = require 'react'
t = require('views/internal/recup-with-helpers')('home')

module.exports = class HomeOrientationComponent extends React.Component
  displayName: 'HomeOrientationComponent'

  render: t.renderable ->
    { title, text, backgroundClass, backgroundTop, onDismissClick } = @props

    t.div '.home-orientation-container', { class: t.classify('background-top': backgroundTop) }, =>
      t.div ".home-orientation-background.#{backgroundClass}", { class: t.classify('background-top': backgroundTop) }
      t.div '.home-orientation-info-container', =>
        t.span '.home-orientation-title', ->
          t.format title
        t.span '.home-orientation-info-text', ->
          t.format text

        if onDismissClick
          t.a '.home-orientation-dismiss.quiet', { onClick: onDismissClick }, ->
            t.format 'orientation-dismiss'



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-orientation-component.coffee